<template>
  <div class="container">
    <div class="page-title">企业审核</div>
    <div class="content">
      <div class="content-top">
        <div class="date-box">
          <div class="label" style="width: 150px;">请选择要查询的日期</div>
          <el-date-picker
            v-model="dateArr"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
          </el-date-picker>
        </div>
        <div class="date-box" style="padding-left: 12px;">
          <div class="label" style="width: 50px;">项目</div>
          <el-select v-model="type" placeholder="请选择" style=" width:150px">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="date-box" style="padding-left: 12px;margin-right: 20px;">
          <el-input
            style=" width:180px"
            placeholder="请输入内容"
            v-model="detail"
            clearable>
          </el-input>
        </div>
        <el-button style="width: 100px;height: 32px;" @click="search" size="small" type="primary">查询</el-button>
      </div>
      <div class="content-bottom">
        <el-table
          :data="tableData"
          stripe
          style="width:100%;flex:1;overflow:auto;"
          v-loading="listLoading"
          >
          <el-table-column
            prop="date"
            label="序号"
            width="100">
            <template slot-scope="scope">
              {{scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="企业名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="name"
            label="法人"
            width="180">
          </el-table-column>
<!--          <el-table-column-->
<!--            label="类型"-->
<!--            width="170">-->
<!--            <template slot-scope="scope">-->
<!--              {{scope.row.role === 7 ? '企业用户' : '设计师'}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="qq"
            label="QQ号"
            width="150">
          </el-table-column>
          <el-table-column
            prop="wechat"
            label="微信号"
            width="150">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机"
            width="150">
          </el-table-column>
          <el-table-column
            label="时间"
            width="170">
            <template slot-scope="scope">
              {{scope.row.createTime | rTime}}
            </template>
          </el-table-column>
          <el-table-column
            label="审核"
            width="160">
            <template slot-scope="scope">
              <div style="color:#67c23a" v-if="scope.row.status === 2">
                <span style="margin-right: 5px;"> 已通过</span>
                <el-button :disabled="!accessConfig.manager"  @click="handleClick2(scope.row,2)" type="danger" size="small">停用</el-button>
              </div>
              <div style="color:#f56c6c"  v-else-if="scope.row.status === 3">
                <span style="margin-right: 5px;">已拒绝</span>
                <el-button :disabled="!accessConfig.manager"  @click="handleClick2(scope.row,1)" type="primary" size="small">通过</el-button>
              </div>
              <div v-else style="display: flex;align-items: center;">
                <el-button :disabled="!accessConfig.manager" @click="handleClick2(scope.row,1)" type="primary" size="small">通过</el-button>
                <el-button :disabled="!accessConfig.manager" @click="handleClick2(scope.row,2)" type="danger" size="small">拒绝</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160">
            <template slot-scope="scope">
              <el-button :disabled="!accessConfig.manager" @click="reset(scope.row.id)" type="primary" size="small">重置密码</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="[5, 10, 20, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
    <el-dialog title="重置密码" :close-on-click-modal="false" :visible.sync="dialogTableVisible" center :append-to-body='true' :lock-scroll="false" width="400px">
      <div class="">
        <div class="first-line">
          <div class="date-box">
            <div class="label" style="width: 90px;text-align: right;">原密码</div>
            <el-input
              show-password
              style="width:200px;"
              placeholder="请输入原密码"
              v-model="oldPswd"
              clearable>
            </el-input>
          </div>
        </div>
        <div class="first-line">
          <div class="date-box">
            <div class="label" style="width: 90px;text-align: right;">新密码</div>
            <el-input
              show-password
              style="width:200px;"
              placeholder="请输入新密码"
              v-model="newPswd"
              clearable>
            </el-input>
          </div>
        </div>
        <div class="first-line">
          <div class="date-box">
            <div class="label" style="width: 90px;text-align: right;">密码确认</div>
            <el-input
              style="width:200px;"
              show-password
              placeholder="请再次输入新密码"
              v-model="newPswd2"
              clearable>
            </el-input>
          </div>
        </div>
        <div style="display: flex;justify-content: center;">
          <el-button width="80px" type="primary" size="mid" style="margin-top: 30px;" @click="confirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dateArr: '',
        orderNumber: '',
        tableData: [],
        options: [{
          value: 'company',
          label: '公司名称'
        }, {
          value: 'name',
          label: '姓名'
        }, {
          value: 'phone',
          label: '手机号码'
        }],
        type: '',
        detail: '',
        total: 0,
        pageSize: 10,
        currentPage:1,
        listLoading: false,
        accessConfig: {},
        id: '',
        oldPswd: '',
        newPswd: '',
        newPswd2: '',
        dialogTableVisible: false
      };
    },
    activated () {
      const functionCodeList = window.sessionStorage.functionCodeList;
      this.accessConfig = {
        manager: functionCodeList.includes('use_menu_account_manager'),
      }
      this.queryData(this.currentPage,this.pageSize);
    },
    methods: {
      queryData(currentPage,pageSize){
        let data = {
          type: this.type,
          detail: this.detail
        }
        if(this.dateArr && this.dateArr.length > 0){
          data.startTime = this.dateArr[0] || '';
          data.endTime = this.dateArr[1] || '';
        }
        this.$http.post(`/user/findCompanyByPage/${currentPage}/${pageSize}`, data, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('res====',res)
            console.log('resdata====',res.data)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.tableData = res.data.data.list;
              this.total = res.data.data.total;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      handleSizeChange: function (size) {
        this.pageSize = size;
        console.log(this.pageSize);  //每页下拉显示数据
        this.queryData(this.currentPage,this.pageSize);
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        console.log(this.currentPage);  //点击第几页
        this.queryData(this.currentPage,this.pageSize);
      },
      handleClick2(row,status) {
        console.log('row========',row);
        const url = status === 2 ? `/user/userRefuse/${row.id}` : `/user/userpass/${row.id}`
        this.$http.post(url, {
          id: row.id
        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.$message.success(res.data.data)
              this.queryData(this.currentPage,this.pageSize);
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      search(){
        this.currentPage = 1;
        this.queryData(this.currentPage,this.pageSize);
      },
      // reset(id){
      //   this.id = id
      //   this.oldPswd = ''  //旺旺名
      //   this.newPswd = ''  //订单号
      //   this.newPswd2 = ''
      //   this.dialogTableVisible = true;
      // },
      reset(id){
        this.$http.post("/user/resetPassword", {
          userId: id
        },{ headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            //  console.log("输出response.data", res.data);
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.$message({
                message: '重置成功',
                type: 'success',
                duration: 800
              });
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      confirm(){
        if(!this.newPswd || !this.newPswd2 || !this.oldPswd){
          this.$message.error('请完整输入信息');
          return;
        }
        if(this.newPswd !== this.newPswd2){
          this.$message.error('两次输入的新密码不一致');
          this.newPswd = '';
          this.newPswd2 = '';
          return;
        }
        this.$http.post("/user/resetPassword", {
          password: this.oldPswd,
          newPassword: this.newPswd,
          userId: this.id
        },{ headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            //  console.log("输出response.data", res.data);
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.id = ''
              this.oldPswd = ''  //旺旺名
              this.newPswd = ''  //订单号
              this.newPswd2 = ''
              this.dialogTableVisible = false;
              this.$message({
                message: '重置成功',
                type: 'success',
                duration: 800
              });
            } else {
              this.$message.error(res.data.data)
            }
          });
      }
    },
    filters: {
      rTime(data) {
        if(!data) return
        var dt = new Date(data);
        var y = dt.getFullYear();
        var m = (dt.getMonth()+1).toString().padStart(2,"0");
        var d = dt.getDate().toString().padStart(2,"0");
        var h = dt.getHours().toString().padStart(2,"0");
        var mm = dt.getMinutes().toString().padStart(2,"0");
        var s = dt.getSeconds().toString().padStart(2,"0");
        return `${y}-${m}-${d} ${h}:${mm}:${s}`;
      },
    }
  };
</script>
<style lang="less" scoped>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex: 1;
    margin-top: 10px;
    .content-top {
      display: flex;
      align-items: center;
      /*margin-top: 10px;*/
      margin-bottom: 10px;
      /*position: fixed;*/
      /*justify-content: flex-start;*/
      /*flex-direction: column;*/
      .first-line {
        display: flex;
        justify-content: flex-start;
      }
      .label {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        /*text-align: right;*/

        color: #000000;
        padding-right: 10px;
      }
      .date-box {
        display: flex;
        align-content: center;
        padding-left: 12px;
      }
    }
    .content-bottom {
      flex: 1;
      /*position: fixed;*/
      /*top: 185px;*/
      /*bottom: 0;*/
      /*left: 147px;*/
      /*right: 0;*/
      overflow: auto;
      /*margin-bottom: 10px;*/
      display: flex;
      flex-direction: column;
    }
    .content-bottom /deep/ .el-table__body {
      /*width: 100%!important;*/
    }
  }
</style>
